import { IParkingOptions } from "../Interfaces/AddressesInterface";

const parkingOptions:IParkingOptions = {
    FREE_STREET:"free street parking",
    METERET: "Meter parking",
    GARAGE_LOG: "parking log or garage",
    VALET_SERVICE :"valet service"
}

export default parkingOptions;